import { CheckCircle, Flame } from 'lucide-react'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface StreakModalProps {
  open: boolean
  onClose: () => void
  currentStreak: number
  /** Whether the streak was just earned (auto-modal after submission) */
  earned?: boolean
}

export function StreakModal({
  open,
  onClose,
  currentStreak,
  earned = false,
}: StreakModalProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-h-[85dvh] gap-2 bg-card p-4 sm:max-w-md sm:gap-3 sm:p-6">
        <DialogHeader className="items-center text-center sm:text-center">
          {earned ? (
            <CheckCircle className="mx-auto h-8 w-8 text-green-500 sm:h-10 sm:w-10" />
          ) : (
            <Flame className="mx-auto h-8 w-8 text-muted-foreground sm:h-10 sm:w-10" />
          )}
          <DialogTitle className="text-base sm:text-lg">
            {earned ? 'Daily Streak Maintained!' : 'Daily Streak'}
          </DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-1">
              <p className="text-sm sm:text-base">
                Completion Streak:{' '}
                <span className="font-bold text-blue-500">{currentStreak}</span>{' '}
                Day{currentStreak !== 1 ? 's' : ''}
              </p>
              <p className="text-muted-foreground text-xs sm:text-sm">
                {earned
                  ? 'Motivation is what gets you started. Habit is what keeps you going.'
                  : 'Complete a challenge to get started today!'}
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        {earned && (
          <div className="mx-auto flex h-[min(10rem,25dvh)] w-full items-center justify-center">
            <img
              src="/apng/timekeeper.apng"
              alt="Spinning timekeeper clock"
              className="h-full w-auto object-contain"
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
